import { Box } from "@mui/material"
import { useMemo } from "react"
import { sanitizeAmendsHtml } from "../../project/amends/lib/sanitize-amends-html"
import { removeEmptyListItems } from "./remove-empty-list-items"
import { buildPdfHtmlDiff, PDF_ADDED_COLOR, PDF_REMOVED_COLOR } from "./build-pdf-html-diff"

export function PdfHtmlDiff({ text, original, other, showRemoved }) {
    const safeText = removeEmptyListItems(sanitizeAmendsHtml(text))
    const safeOriginal = removeEmptyListItems(sanitizeAmendsHtml(original))
    const safeOther = removeEmptyListItems(sanitizeAmendsHtml(other))
    const html = useMemo(compareDiff, [safeOther, safeOriginal, safeText, showRemoved])

    return (
        <Box
            className="styled-bullets"
            dangerouslySetInnerHTML={{ __html: html }}
            sx={{
                fontSize: "10px",
                lineHeight: 1.5,
                color: "#111827",
                "& p": { m: 0, mb: "4px" },
                "& ul, & ol": { my: "4px", pl: "18px" },
                "& li": { mb: "2px" },
                "& li.pdf-diff-added::before, & li.pdf-diff-added::marker": { color: PDF_ADDED_COLOR },
                "& li.pdf-diff-removed::before, & li.pdf-diff-removed::marker": {
                    color: PDF_REMOVED_COLOR,
                    textDecoration: "line-through",
                },
                "& table": { width: "100%" },
                "& img": { maxWidth: "100%" },
            }}
        />
    )

    function compareDiff() {
        return buildPdfHtmlDiff({ text: safeText, original: safeOriginal, other: safeOther, showRemoved })
    }
}
